define(['tpaComponents/bi/errors.json', 'lodash', 'coreUtils'], function (errors, _, coreUtils) {
    'use strict';

    const logger = coreUtils.loggingUtils.logger;

    /**
     * Please ctrl/cmd + click on biError to see the schema :)
     * @type {Object.<String, biError>}
     */

    _.forEach(errors, function (error, key) {
        error.errorName = key; // eslint-disable-line santa/no-side-effects
    });

    logger.register('tpa', 'error', errors);

    return errors;
});
